// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.tab-button-small {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  border: 1px solid #EDF0F1;
  background: white;
  color: #444343;
  min-width: 80px;
  max-width: 96px;
  width: 10%;
  transition: 0.1s ease;
  padding: 4px 8px;
  font-size: 1.1em;
}
.tab-button-small p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}

.tab-button-small-no-width {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  border: 1px solid #EDF0F1;
  background: white;
  color: #444343;
  transition: 0.1s ease;
  padding: 4px 16px;
  font-size: 1.1em;
}
.tab-button-small-no-width p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}
.tab-button-small-no-width:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tab-button-selected-small {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #0669B3;
  border: 1px solid #0669B3;
  color: white;
  max-width: 96px;
  min-width: 80px;
  width: 10%;
  font-size: 1.1em;
  padding: 4px 8px;
  transition: 0.1s ease;
}
.tab-button-selected-small .small,
.tab-button-selected-small p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}

.tab-button-selected-small-no-width {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #0669B3;
  border: none;
  color: white;
  font-size: 1.1em;
  padding: 4px 16px;
  transition: 0.1s ease;
}
.tab-button-selected-small-no-width .small,
.tab-button-selected-small-no-width p.primary {
  margin: 0px;
  font-size: 1.2em;
  font-weight: 500;
}
.tab-button-selected-small-no-width:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tab-button-large {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  border: 1px solid #EDF0F1;
  background: white;
  color: #444343;
  min-width: 80px;
  width: 125px;
  transition: 0.1s ease;
  padding: 4px 8px;
}
.tab-button-large p.primary {
  margin: 0px;
  font-size: 2em;
  font-weight: 500;
}
.tab-button-large p.secondary {
  margin: 0px;
  font-size: 0.8em;
  font-weight: 500;
}

.tab-button-selected-large {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #0669B3;
  border: 1px solid #0669B3;
  color: white;
  width: 125px;
  min-width: 80px;
  padding: 4px 8px;
  transition: 0.1s ease;
}
.tab-button-selected-large p.primary {
  margin: 0px;
  font-size: 2em;
  font-weight: 500;
}
.tab-button-selected-large p.secondary {
  margin: 0px;
  font-size: 0.8em;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TabButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,kBADyB;EAsBzB,2CAAA;EDlBA,yBAAA;EACA,iBAAA;EACA,cDwBK;ECvBL,eAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAUJ;AARI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAUR;;AANA;ECpBI,kBADyB;EAsBzB,2CAAA;EDEA,yBAAA;EACA,iBAAA;EACA,cDIK;ECHL,qBAAA;EACA,iBAAA;EACA,gBAAA;AASJ;AAPI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AASR;AANI;EACI,YAAA;EACA,mBAAA;AAQR;;AAJA;EC1CI,kBADyB;EAsBzB,2CAAA;EDwBA,mBDfS;ECgBT,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAOJ;AALI;;EAEI,WAAA;EACA,gBAAA;EACA,gBAAA;AAOR;;AAHA;EC/DI,kBADyB;EAsBzB,2CAAA;ED6CA,mBDpCS;ECqCT,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAMJ;AAJI;;EAEI,WAAA;EACA,gBAAA;EACA,gBAAA;AAMR;AAHI;EACI,YAAA;EACA,mBAAA;AAKR;;AAAA;ECvFI,kBADyB;EAsBzB,2CAAA;EDqEA,yBAAA;EACA,iBAAA;EACA,cD/DK;ECgEL,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAGJ;AADI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;AAGR;AAAI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAER;;AAEA;EC/GI,kBADyB;EAsBzB,2CAAA;ED6FA,mBDpFS;ECqFT,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AACJ;AACI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAAR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.tab-button-small {\n    @include borderRadius();\n    @include shadow();\n    border: 1px solid $grey0;\n    background: white;\n    color: $grey4a;\n    min-width: 80px;\n    max-width: 96px;\n    width: 10%;\n    transition: 0.1s ease;\n    padding: 4px 8px;\n    font-size: 1.1em;\n\n    p.primary {\n        margin: 0px;\n        font-size: 1.2em;\n        font-weight: 500;\n    }\n}\n\n.tab-button-small-no-width {\n    @include borderRadius();\n    @include shadow();\n    border: 1px solid $grey0;\n    background: white;\n    color: $grey4a;\n    transition: 0.1s ease;\n    padding: 4px 16px;\n    font-size: 1.1em;\n\n    p.primary {\n        margin: 0px;\n        font-size: 1.2em;\n        font-weight: 500;\n    }\n\n    &:disabled {\n        opacity: .5;\n        cursor: not-allowed;\n    }\n}\n\n.tab-button-selected-small {\n    @include borderRadius();\n    @include shadow();\n    background: $pearl-blue;\n    border: 1px solid $pearl-blue;\n    color: white;\n    max-width: 96px;\n    min-width: 80px;\n    width: 10%;\n    font-size: 1.1em;\n    padding: 4px 8px;\n    transition: 0.1s ease;\n\n    .small,\n    p.primary {\n        margin: 0px;\n        font-size: 1.2em;\n        font-weight: 500;\n    }\n}\n\n.tab-button-selected-small-no-width {\n    @include borderRadius();\n    @include shadow();\n    background: $pearl-blue;\n    border: none;\n    color: white;\n    font-size: 1.1em;\n    padding: 4px 16px;\n    transition: 0.1s ease;\n\n    .small,\n    p.primary {\n        margin: 0px;\n        font-size: 1.2em;\n        font-weight: 500;\n    }\n\n    &:disabled {\n        opacity: .5;\n        cursor: not-allowed;\n    }\n}\n\n\n.tab-button-large {\n    @include borderRadius();\n    @include shadow();\n    border: 1px solid $grey0;\n    background: white;\n    color: $grey4a;\n    min-width: 80px;\n    width: 125px;\n    transition: 0.1s ease;\n    padding: 4px 8px;\n\n    p.primary {\n        margin: 0px;\n        font-size: 2em;\n        font-weight: 500;\n    }\n\n    p.secondary {\n        margin: 0px;\n        font-size: 0.8em;\n        font-weight: 500;\n    }\n}\n\n.tab-button-selected-large {\n    @include borderRadius();\n    @include shadow();\n    background: $pearl-blue;\n    border: 1px solid $pearl-blue;\n    color: white;\n    width: 125px;\n    min-width: 80px;\n    padding: 4px 8px;\n    transition: 0.1s ease;\n\n    p.primary {\n        margin: 0px;\n        font-size: 2em;\n        font-weight: 500;\n    }\n\n    p.secondary {\n        margin: 0px;\n        font-size: 0.8em;\n        font-weight: 500;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
